import { Flex, Text } from "@chakra-ui/react";

import {
  PACKAGE_TIMELINE,
  SHIPMENT_TIMELINE,
} from "@features/services/shipping/shipmentEvents";
import TimelineStepList from "@features/services/shipping/TimelineStepList";
import type { ShipmentEvent } from "@features/services/shipping/TrackingView";
import { formatMeasured } from "@features/services/shipping/measuredTotals";
import { formatTimestamp } from "helpers/formatTimestamp";

export interface ReceivedPackageData {
  id: number;
  sequenceNum: number;
  receivedAt: Date;
  // What the warehouse counted for this package. Null when it was scanned in
  // on the floor rather than measured on a loading sheet.
  cartons: number | null;
  cbm: number | null;
  events: ShipmentEvent[];
}

interface ShipmentTimelineProps {
  events: ShipmentEvent[];
  receivedPackages: ReceivedPackageData[];
}

const ShipmentTimeline = ({
  events,
  receivedPackages,
}: ShipmentTimelineProps) => {
  return (
    <Flex direction="column" gap={6}>
      <Flex direction="column" gap={2}>
        <Text fontSize="xs" fontWeight="semibold" color="text.secondary">
          Shipment
        </Text>
        <TimelineStepList steps={SHIPMENT_TIMELINE} events={events} />
      </Flex>
      {receivedPackages.map((pkg) => {
        const measured = formatMeasured(pkg.cartons, pkg.cbm);
        return (
          <Flex key={pkg.id} direction="column" gap={2}>
            <Flex direction="column" gap={0}>
              <Flex align="baseline" justify="space-between" gap={3}>
                <Text fontSize="sm" fontWeight="semibold" color="text.primary">
                  Package #{pkg.sequenceNum}
                </Text>
                {measured !== "" && (
                  <Text fontSize="xs" color="fg.muted">
                    {measured}
                  </Text>
                )}
              </Flex>
              <Text fontSize="xs" color="text.secondary">
                Received {formatTimestamp(pkg.receivedAt)}
              </Text>
            </Flex>
            <TimelineStepList steps={PACKAGE_TIMELINE} events={pkg.events} />
          </Flex>
        );
      })}
    </Flex>
  );
};

export default ShipmentTimeline;
